export const ADD_COMMENT = 'ADD_COMMENT';
export const DISHES_LOADING = 'DISHES_LOADING';
export const DISHES_FAILED = 'DISHES_FAILED';
export const ADD_DISHES = 'ADD_DISHES';
export const ADD_COMMENTS = 'ADD_COMMENTS';
export const COMMENTS_FAILED = 'COMMENTS_FAILED';
export const PROMOS_LOADING = 'PROMOS_LOADING';
export const ADD_PROMOS = 'ADD_PROMOS';
export const PROMOS_FAILED = 'PROMOS_FAILED';
export const ADD_TASK = 'ADD_TASK';
export const ADD_TASKS = 'ADD_TASKS';
export const TASKS_FAILED = 'TASKS_FAILED';
export const NEW_TASK = 'NEW_TASK';
export const TASKS_LOADING = 'TASKS_LOADING';
export const UPDATE_LOG = 'UPDATE_LOG';
export const SAVE_UPDATE_TO_LOG = 'SAVE_UPDATE_TO_LOG';
export const GET_ALL_TASKS = 'GET_ALL_TASKS';
export const ADD_TASK_TO_ALLTASKS = 'ADD_TASK_TO_ALLTASKS';
export const ADD_TIMETABLE = 'ADD_TIMETABLE';
export const UPDATE_TIMETABLE = 'UPDATE_TIMETABLE';
export const GET_TIMETABLES = 'GET_TIMETABLES';
export const DELETE_TIMETABLE = 'DELETE_TIMETABLE';
export const UPDATE_TASK_TO_ALL_TASKS = 'UPDATE_TASK_TO_ALL_TASKS';
export const GET_OPEN_AI_RESPONSE = 'GET_OPEN_AI_RESPONSE';







